export default [
  {
    path: '/apps/tipo-pic/list',
    name: 'apps-tipo-pic-list',
    component: () => import('@/views/cadastros/apoio-vendas/tipo-pic/list/Index.vue'),
    meta: {
      pageTitle: 'Tipo Pic',
    },
  },
  // {
  //     path: '/apps/tipo-pic/edit/:id',
  //     name: 'apps-tipo-pic-edit',
  //     component: () => import('@/views/cadastros/apoio-vendas/tipo-pic/tipo-pic-edit/TipoPicEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar TipoPic',
  //     },
  // },
];
